// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NzxA9","right":"styles_right__C-C9e"};